import React, {useState} from "react"
import Styles from "./selectDiff.less"
import downSelect from "../../../../../static/pic/downSelect.svg"
import upSelect from "../../../../../static/pic/upSelect.svg"
import {UseListData} from "../../../../../function/hooks/useDataFromRedux"

interface DiffSelectProps {
    num: number
    handleChange: (optionType: string) => void
}

const DiffSelect: React.FunctionComponent<DiffSelectProps> = (props) => {
    const diffList = [
        {name: "全部", value: "all"},
        {name: "新增", value: "insert"},
        {name: "修改", value: "replace"},
        {name: "删除", value: "delete"},
    ]
    const listData = UseListData()
    const [type, setType] = useState<{name: string; value: string}>({name: "全部", value: "all"})
    const getStyle = (value: string) => {
        if (value !== type.value) {
            return
        }
        return {
            borderBottom: "1px solid #5582FE",
        }
    }
    const getNum = (type: string) => {
        switch (type) {
            case "insert":
                return listData.insert.length
            case "replace":
                return listData.replace.length
            case "delete":
                return listData.delete.length
            case "all":
                return listData.insert.length + listData.replace.length + listData.delete.length
            default:
        }
    }
    return (
        <div className={Styles.selectOutBox}>
            {diffList.map((item) => {
                return (
                    <div
                        className={Styles.selectDiffTypeItem}
                        onClick={() => {
                            setType(item)
                            props.handleChange(item.value)
                        }}
                        style={getStyle(item.value)}
                        key={item.value}
                    >
                        {`${item.name}(${getNum(item.value)})`}
                    </div>
                )
            })}
        </div>
    )
}

export default DiffSelect
